
import { library } from '@fortawesome/fontawesome-svg-core'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faFilter, faSearch } from '@fortawesome/free-solid-svg-icons'

import PropTypes from 'prop-types'
import React, { Fragment as F, useContext, useEffect, useState } from 'react'
import Select from 'react-select'

import {
  SchedulesCtx,
} from '../schedules'
import {
  useApiRouter,
  C,
  logg,
} from '$shared'

import {
  AppCtx,
} from '$src/App'
import {
  ReportsCtx,
} from '.'

library.add( faFilter, faSearch )

/*
 * TriSelect
**/
const TriSelect = (props) => {
  // logg(props, 'TriSelect')
  const {
    clear,
    filteredUbprsList, setFilteredUbprsList,
  } = props

  const apiRouter = useApiRouter()

  /* ctx */

  const {
    setLoading,
  } = useContext(AppCtx)

  const {
    allUbprCodes,
  } = useContext(ReportsCtx)
  // logg(useContext(ReportsCtx), 'ReportsCtx in TriSelect')

  const {
    schedulesList,
  } = useContext(SchedulesCtx)
  // logg(useContext(SchedulesCtx), 'SchedulesCtx in TriSelect')

  /* state */

  const defaultSelectedThird = `${C.thirds.bySchedule} ${C.thirds.byKeyword}` // ${C.thirds.addExtra}`
  const [ selectedThird, setSelectedThird ] = useState(defaultSelectedThird)
  const [ selectedSchedule, setSelectedSchedule ] = useState(null)
  const [ ubprsListFilter, setUbprsListFilter ] = useState('')

  /* select a schedule */
  useEffect(() => {
    if (selectedSchedule) {
      setLoading(true)
      fetch(apiRouter.ubprCodesPath({ schedule_id: selectedSchedule })).then(r => r.json()).then(inns => {
        // logg(inns, `ubprCodes of schedule ${selectedSchedule}`)
        setFilteredUbprsList(inns)
        setSelectedThird(C.thirds.bySchedule)
        setLoading(false)
      })
    } else {
      setSelectedThird(defaultSelectedThird)
      setFilteredUbprsList([])
    }
  }, [ selectedSchedule, allUbprCodes ])

  /* redmine issue#3392 */
  const filterUbprsList = (ev) => {
    ev.preventDefault()
    clear()

    const val = ubprsListFilter.toLowerCase()
    setSelectedThird(C.thirds.byKeyword)
    setSelectedSchedule(null)

    const tmp = allUbprCodes.filter((li, idx) =>
      li.label.toLowerCase().indexOf(val) !== -1
    )
    const exact = allUbprCodes.filter((li, idx) =>
      li.label.toLowerCase() === val
    )
    setFilteredUbprsList( tmp.length === 1 ? tmp : exact.concat(tmp) )
  }


  return <F>
    <div className='TriSelectW'>
      <div className='tri-select'>
        <div className={`one-third ${selectedThird.indexOf(C.thirds.bySchedule) === -1 ? 'inactive' : ''}`} >
          <label>Choose from a Schedule</label>
          <Select
            isClearable={true}
            isDisabled={selectedThird.indexOf(C.thirds.bySchedule) === -1}
            options={schedulesList}
            value={schedulesList.filter(e => e.value === selectedSchedule)}
            // styles={C.select2Styles}
            onChange={(ev) => {
              clear()
              if (ev) {
                setSelectedSchedule(ev.value)
              } else {
                setSelectedSchedule(null) ;
              }
            } }
          />
        </div>
        <div className={`-or- ${selectedThird.indexOf(C.thirds.bySchedule) > -1 && selectedThird.indexOf(C.thirds.byKeyword) > -1 ? '' : 'inactive'}`}>-or-</div>
        <div className={`two-third ${selectedThird.indexOf(C.thirds.byKeyword) === -1 ? 'inactive' : ''}`} >
          <label>Search Line Items</label>
          <div className='upbrs-list-filterW'>
            <form onSubmit={filterUbprsList} >
              <input className={`upbrs-list-filter ${ubprsListFilter === '' ? '' : 'nonempty' }`}
                disabled={selectedThird.indexOf(C.thirds.byKeyword) === -1}
                onChange={(ev) => setUbprsListFilter(ev.target.value) }
                value={ubprsListFilter}
              />
              { ubprsListFilter !== '' && <div className='clear'
                onClick={() => {
                  setUbprsListFilter('')
                  setFilteredUbprsList([])
                  setSelectedThird(defaultSelectedThird)
                  clear()
                } }
              >&times;</div> }
              <FontAwesomeIcon
                icon="fa-solid fa-search"
                onClick={filterUbprsList}
                // @TODO: its not always pointer
                style={{ cursor: 'pointer', fontSize: '1.3em',
                  color: selectedThird.indexOf(C.thirds.byKeyword) === -1 ? '#bbb' : 'gray',
                  position: 'absolute', right: '0.4em', top: '0.4em' }}
              />
            </form>
          </div>
        </div>
      </div>
    </div>
  </F>
}
export default TriSelect
TriSelect.propTypes = {
  clear: PropTypes.func.isRequired,
  setFilteredUbprsList: PropTypes.func.isRequired,
};
